module.exports = __webpack_public_path__ + "assets/img/CMTP-Website-w720.4f63334f.webp";